
import { Field, Form, Toast } from "vant";
import { Component, Vue } from "vue-property-decorator";
import { sellInfo, coinNum, sendSms, publish } from "@/req/user";
@Component({
  components: { Field, Form },
})
export default class Logout extends Vue {
  public active = 0;
  public goldActive = 0;
  public roleList = [];
  public gameId: any = "";
  public gameName: any = "";
  public serverId: any = "";
  public serverName: any = "";
  public roleId: any = "";
  //   public obj: any = this.$route.query.obj;
  public servicePercent = ""; // 服务费比例（单位:%）
  public phone = ""; // 当前用户手机
  public isCheck: any = ""; // 是否需要验证码校验
  public role: any = {};
  public smsCountTime = 0;
  public coinConfigId: any = ""; // 货币id
  public coinNum: any = ""; // 货币数量
  public price: any = ""; // 售价
  public code = ""; // 验证码
  public targetRole = ""; // 指定购买人角色名
  public coinMinSellCount = 0;
  public coinMinPrice = 0;

  public item = {
    commodity_title: "123",
    commodity_career: "123",
    commodity_detail: "123",
    game_name: "123",
  };
  public coinList: any = [];
  public created() {
    this.gameName = this.$route.query.gameName;
    this.gameId = this.$route.query.gameId;
    this.serverId = this.$route.query.serverid;
    this.serverName = this.$route.query.serverName;
    this.roleId = this.$route.query.id;
    this.getRoleInfo();
  }
  // 获取角色详情
  public async getRoleInfo() {
    const obj = {
      box_game_id: this.gameId,
      server_id: this.serverId,
    };
    const res = await sellInfo(obj);
    if (res.code == 200) {
      this.phone = res.data.phone;
      this.isCheck = res.data.is_check;
      this.servicePercent = res.data.service_percent;
      res.data.role.forEach((element) => {
        if (element.role_id == this.roleId) {
          this.role = element;
          this.getCoin();
        }
      });
    }
  }
  public async getCoin() {
    const obj = {
      box_game_id: this.gameId,
      server_id: this.serverId,
      role_id: this.roleId,
    };
    const res = await coinNum(obj);
    if (res.code == 200) {
      this.coinList = res.data.coin_list;
    }
  }
  //   短信验证码倒计时
  public smsCountDown() {
    if (this.smsCountTime !== 0) {
      this.smsCountTime--;
      setTimeout(() => {
        this.smsCountDown();
      }, 1000);
    }
  }
  // 获取验证码
  public async getSmsCode() {
    const res = await sendSms({ a: "1" });
    if (res.code == 200) {
      this.smsCountTime = 60;
      this.smsCountDown();
    }
  }
  public selectCoin(item, index) {
    this.coinConfigId = item.coin_config_id;
    this.coinMinSellCount = this.coinList[index].coin_min_sell_count;
    this.coinMinPrice = this.coinList[index].coin_min_price;
  }
  // 发布商品
  public async submit() {
    if (this.coinNum < 1) {
      Toast("请输入售卖数量");
      return false;
    }
    if (this.price < 0) {
      Toast("请输入售卖金额");
      return false;
    }
    if (this.coinNum < this.coinMinSellCount) {
      Toast("售卖数量低于最低售卖数量");
      return false;
    }
    if (this.price < this.coinMinPrice * this.coinNum) {
      Toast("售价低于最低售卖金额");
      return false;
    }
    const obj = {
      box_game_id: this.gameId,
      server_id: this.serverId,
      role_id: this.roleId,
      coin_config_id: this.coinConfigId,
      coin_num: this.coinNum,
      price: this.price,
      code: this.code,
      target_role: this.targetRole,
    };
    const res = await publish(obj);
    if (res.code == 200) {
      //   const $dislog: any = this.$refs.dislog;
      //   $dislog.show(6, res.data.commodity_id);
      Toast("寄售成功");
      this.$router.push("/shelves");
    }
  }
}
